import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBiJACb1vNaH01GjHwVc9sA6BVab8iFA0A",
  authDomain: "affiearn-ad591.firebaseapp.com",
  databaseURL: "https://affiearn-ad591-default-rtdb.firebaseio.com",
  projectId: "affiearn-ad591",
  storageBucket: "affiearn-ad591.firebasestorage.app",
  messagingSenderId: "108555316077",
  appId: "1:108555316077:web:8093633724e6cf7d778864",
  measurementId: "G-DLKELVP7F3"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);

